import { ConversationStatus } from '@provision/conversation-types';
import dayjs from 'dayjs';
import { formatDateToLocalString } from 'src/components/SidePanelTabs/MembershipInformation/subscription-details.utils';
import { Conversation } from 'src/graphql';
import { ChatInfoWithTimestamp } from './chat-info-messages';
import { OPTIONS_LOCALE } from './partner-holiday-message';

export function getSnoozeConversationMessage(
  conversation?: Conversation,
  color?: string,
  hourCycle: 'h12' | 'h24' = 'h24',
) {
  const conversationStatusId = conversation?.conversationStatusId as ConversationStatus;
  const isValidSnoozedConversation =
    !conversation?.snoozeUntil ||
    dayjs().isAfter(dayjs(conversation.snoozeUntil)) ||
    conversationStatusId !== ConversationStatus.Snoozed;

  if (isValidSnoozedConversation) {
    return;
  }

  const diff = new Date(conversation.snoozeUntil ?? '').getTime() - new Date().getTime();
  const formattedDate = formatDateToLocalString({
    date: conversation.snoozeUntil,
    options: { ...OPTIONS_LOCALE, hourCycle },
  });
  const humanizeDuration = dayjs.duration(diff).humanize();
  const message = `Snoozed for ${humanizeDuration} | ${formattedDate}`;

  return (
    <ChatInfoWithTimestamp
      icon="snooze"
      date={conversation.snoozeUntil}
      message={message}
      partnerId={conversation.partnerId}
      color={color}
    />
  );
}
